import angular from 'angular';

import logServiceModule from './LogService';
import apiServiceModule from './APIService';
import enUSTranslations from '../../../_buildconfig/translations/en_US.json';
import frCATranslations from '../../../_buildconfig/translations/fr_CA.json';


/**
 * TODO: Make these translations dynamic somehow
 */

const localTranslationsByLocale = {
  'en_US': enUSTranslations,
  'fr_CA': frCATranslations,
};

const apiTranslationsPath = '/translation';

class TranslationService {
  constructor($injector, $q, LogService) {
    "ngInject";
    this.$injector = $injector;
    this.$q = $q;
    this.translations = [];
    this.LogService = LogService;

    this._languagePromisesByLocale = {};
    this._loadedLanguagesByLocale = {};
  }

  get APIService() {
    if (!this._APIService) {
      this._APIService = this.$injector.get('APIService');
    }
    return this._APIService;
  }

  get loadedLocales() {
    return Object.keys(this._loadedLanguagesByLocale);
  }

  loadTranslations(languageKey) {
    if (!this._languagePromisesByLocale[languageKey]) {
      let loadingPromise;
      if (localTranslationsByLocale[languageKey]) {
        this.LogService.debug(`Loading local translations for ${languageKey}`);
        loadingPromise = this.$q.when(localTranslationsByLocale[languageKey]);
      } else {
        this.LogService.debug(`Loading API translations for ${languageKey}`);
        loadingPromise = this.loadAPITranslations(languageKey);
      }
      this._languagePromisesByLocale[languageKey] = loadingPromise
        .catch(err => {
          this.LogService.warn(`Error loading language ${languageKey}:`, err);
          return this.$q.reject(err);
        })
        .then(language => {
          this.LogService.debug(`Loaded locale ${languageKey}:`, language);
          this._loadedLanguagesByLocale[languageKey] = language;
          return language;
        });
    }
    return this._languagePromisesByLocale[languageKey];
  }

  loadAPITranslations(languageKey) {
    return this.APIService.get(apiTranslationsPath, {params: {lang: languageKey}})
      .then(response => {
        this.translations = response.data;
        return this.translations;
      })
      .catch(err => {
        this.LogService.warn('Error loading translations from API', err);
        return this.$q.reject(err);
      });
  }

  /**
   * Given an array of language keys (locales), attempt to load all with TranslationService.loadTranslations(), and
   * swallow errors for languages that fail to load
   * @param languageKeys
   */
  attemptToLoadMultipleTranslations(languageKeys) {
    const languagePromises = languageKeys.map(languageKey => {
      return this.loadTranslations(languageKey)
        .then(language => [languageKey, language])
        .catch(err => {
          this.LogService.warn(`TranslationService.attemptToLoadMultipleTranslations swallowing error with ${languageKey}:`, err);
          return null;
        })
    });
    return this.$q.all(languagePromises)
      .then(result => {
        return result;
      })
      .then(languageInfos => languageInfos.filter(languageInfo => !!languageInfo))
      .then(languageInfos => {
        return languageInfos.map(languageInfo => {
          return languageInfo[0];
        });
      })
      .then(result => {
        return result;
      });
  }

  convertKeyToCapitalizedSentence(str) {
    let result = str.toLowerCase();
    result = result.replace(/_/g, ' ');
    result = result.replace(/(?:^|\s)\S/g, (chr) => {
      return chr.toUpperCase();
    });
    return result;
  }
}

const moduleName = 'recaps.service.translation';
const module = angular.module(moduleName, [
  logServiceModule.name,
  apiServiceModule.name,
]);

module.service('TranslationService', TranslationService);

export default module;
